import apiUrl from '../../../constants'
import CommonFunctions from '../../../CommonFunctions'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';



export default {
    name: 'user',
    components: {
        Paginate,
        VueElementLoading,
        Multiselect
    },
    data: function() {
        return {
            modalShow: false,
            mobileverificationmodalShow : false,
            forcedLogoutmodalShow: false,
            modalclient:false,
            listUserData: [],
            hubServiceCenterList:[],
            clientsList:[],
            iptrackData:'',
            props: [],
            pageno: 0,
            pagecount: 0,
            username: (!window.localStorage.getItem('LSUsername')) ? '' : window.localStorage.getItem('LSUsername'),
            newuserid: (!window.localStorage.getItem('LSuserids')) ? '' : window.localStorage.getItem('LSuserids'),
            olduserid: (!window.localStorage.getItem('LSolduserid')) ? '' : window.localStorage.getItem('LSolduserid'),
            userid: '' ,
            hubid: (( window.localStorage.getItem('LSHubId')) == 'undefined' || ( window.localStorage.getItem('LSHubId')) == null) ? '' : this.fillHubData(),
            clientid: (( window.localStorage.getItem('LSClientId')) == 'undefined' || ( window.localStorage.getItem('LSClientId')) == null) ? '' : this.fillClientData(),
            isLoading: false,
            resultCount: '',
            mobilenumber:(!window.localStorage.getItem('LSMobile')) ? '' : window.localStorage.getItem('LSMobile'),
            status: "",
            userstatus: (!window.localStorage.getItem('LSStatus')) ? '' : window.localStorage.getItem('LSStatus'),
            changestatus: '',
            count: 0,
            email: (!window.localStorage.getItem('LSEmail')) ? '' : window.localStorage.getItem('LSEmail'),
            localuserid: 0,
            listUserTypeData: [],
            utype:(!window.localStorage.getItem('LSUtype')) ? '' : window.localStorage.getItem('LSUtype'),
            logOutDevice: '',
            tripclosemodal : false,
            triptrack : '',
            listTrackData:[],
            listRolesData:[],
            trackname : '',
            rolename : '',
            istrackloader : false,
            isRoleloader : false,
            showRoles : false,
            usercount : 0,
            clientUserData:{},
            successMsg:'',
            isCopy:false,
            isShowClientCredentials:false,
            mappinguserhubs_component: false,
            overrideuseraccess_component: false,
            userclientmap_component: false,
            edituser_component: false,
            IsLoggedIn_component: false,
            IsMobileLoggedIn_component: false,
            tripclose_component: false,
            checklivestatus:'',
            ismobileverification_component: false,
            ismobileverifiedflag : false,
            mobileflaguserid : '',
            web2faflagmodalShow : false,
            web2faflagmodalShowtruemsg:"",
            web2faflag: null,
        }
    },
    created: function() {

    },
    async mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail
        let iptrck= await iptrackerdetails.checkUserIPV2(this.iptrackData,'Users List',this.$route.path);
        //console.log(iptrck);
        if(iptrck){
          this.$router.push('/');
        }
        this.userroleid = Number(userdetail.roleid);
        this.supportUser = userdetail.isSystemLoggedIn
        this.userroleids = apiUrl.rolesids;
        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;


        this.pageno = 0;
        this.getHubServiceCenterData();
        this.getUserData();
        this.getUserTypeData();
        this.getTrackNames();
        this.getClientListData();
        this.selectUserType();
        var permissionEncrypt = window.localStorage.getItem('permissiondata');
        var permissionbytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
        var permissionplaintext = permissionbytes.toString(CryptoJS.enc.Utf8);
        var permissionDetails = JSON.parse(permissionplaintext);


        CommonFunctions.prototype.checkURL(permissionDetails, ["showclientcredentials", "maphubsusers", "appuserprojectroles", "userclientmap", "register", "accessprojects", "IsLoggedIn", "IsMobileLoggedIn", "tripclosemodal","accesssubdepartment","ismobileverification"]).then(value => {
          if (value.showclientcredentials) {
            this.isShowClientCredentials = value.showclientcredentials
          }
          if (value.maphubsusers) {
            this.mappinguserhubs_component = value.maphubsusers
          }
          if (value.appuserprojectroles) {
            this.overrideuseraccess_component = value.appuserprojectroles
          }
          if (value.userclientmap) {
            this.userclientmap_component = value.userclientmap
          }
          if (value.register) {
            this.edituser_component = value.register
          }
          if (value.accessprojects) {
            this.accessprojects_component = value.accessprojects
          }
          if (value.IsLoggedIn) {
            this.IsLoggedIn_component = value.IsLoggedIn
          }
          if (value.IsMobileLoggedIn) {
            this.IsMobileLoggedIn_component = value.IsMobileLoggedIn
          }
          if (value.tripclosemodal) {
            this.tripclose_component = value.tripclosemodal
          }
          if (value.accesssubdepartment) {
            this.mappingsubdepartment_component = value.accesssubdepartment
          }
          if (value.ismobileverification) {
            this.ismobileverification_component = value.ismobileverification
            this.ismobileverifiedflag = true
          }
        }, reason => {
          this.isShowClientCredentials = false
          this.mappinguserhubs_component = false
          this.overrideuseraccess_component = false
          this.userclientmap_component = false
          this.edituser_component = false
          this.accessprojects_component = false
          this.IsMobileLoggedIn_component = false
          this.IsMobileLoggedIn_component = false
          this.tripclose_component = false
          this.mappingsubdepartment_component = false
          this.ismobileverification_component = false
        });



    },
    methods: {
        fillHubData(){
          var hubfill = [];
          hubfill={
            id : window.localStorage.getItem('LSHubId'),
            label : window.localStorage.getItem('LSHub')
          }
          this.hubServiceCenterList = hubfill;
          return hubfill;
        },
        fillClientData(){
          var clientfill = [];
          clientfill={
            id : window.localStorage.getItem('LSClientId'),
            label : window.localStorage.getItem('LSClient')
          }
          this.clientsList = clientfill;
          return clientfill;
        },
        addNewUser() {
            this.$router.push('/register');
        },

        setupClient(userid,clientid){
         let encrypted_clientid =  CommonFunctions.prototype.encryptData(clientid.toString());
         this.$router.push('/register/'+userid+'?clientuserdata='+encrypted_clientid);
      },
        getUserSettings(userid){
          this.$router.push('/appuserprojectroles/'+userid);
        },
        getUserAccessSettings(userid){
          this.$router.push('/accessprojects/'+userid);
        },
        getUserClientMap(userid){
          this.$router.push('/userclientmap/'+userid)
        },
        closeStatusUserModal() {
            this.modalShow = false
        },
        closeforcedLogoutModal() {
            this.forcedLogoutmodalShow = false
        },
        getHubServiceCenterData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = {}
          axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/gethubservicecenterlist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              var data = [];
              result.data.hubs.data.forEach(function (hubData) {
                data.push({
                  id:hubData.HubID,
                  label:hubData.HubName
                });
              });
              global.hubServiceCenterList = data;
            }, error => {
              console.error(error)
            })
        },
        getClientListData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = {}
          axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/getclientlist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              var data = [];
              result.data.clients.data.forEach(function (clientData) {
                data.push({
                  id:clientData.ClientMasterID,
                  label:clientData.CompanyName + "("+clientData.ClientMasterID+")"
                });
              });
              this.clientsList = data;
            }, error => {
              console.error(error)
            })
        },
        searchUserData() {
          this.pageno = 0;
          this.$refs.paginate.selected = 0;
          this.getUserData();
        },
        getMobileVerifiedData(userid) {
          this.mobileflaguserid = userid
           var element = document.getElementById("#confirmationmodal1");
           element.classList.add("show");
            this.mobileverificationmodalShow = true
        },
        closeStatusMobileVerificationModal() {
          this.mobileverificationmodalShow = false
      },
  getMobileVerifiedLinkData1(userid,web2faotp) {
          this.mobileflaguserid = userid
          if(web2faotp){
            this.web2faflagmodalShowtruemsg ="Are you considering changing the OTP communication method to SMS?"
            this.web2faflag = false
          }else{
            this.web2faflagmodalShowtruemsg ="Are you considering changing the OTP communication method to email?"
            this.web2faflag = true
          }
           var element = document.getElementById("#confirmationmodal3");
           element.classList.add("show");
           var userToken = window.localStorage.getItem('userToken')
           var myStr = userToken.replace(/"/g, '');
           this.web2faflagmodalShow = true;
        },
        // Mobile Verification Link
        closeStatusweb2faflagModal() {
        this.web2faflagmodalShow = false
    },
 changeweb2faStatus(){
      this.isLoading = true;
      var userToken = window.localStorage.getItem('userToken')
      var myStr     = userToken.replace(/"/g, '');
      let reqpayload = {
        'userid' : this.mobileflaguserid,
        'web2faotpflag' : this.web2faflag
      }

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'users/web2faotpflag',
          'data': reqpayload,
          headers: {
              'Authorization': 'Bearer ' + myStr
          }
      })
      .then((response) => {
        this.isLoading = false;
          if (response.data.code == 200) {
              this.web2faflagmodalShow = false;
              this.$alertify.success(response.data.msg);
              window.setTimeout(()=>{
                window.location.reload();
              },3000)
          } else {
             this.web2faflagmodalShow = false;
              this.$alertify.error(response.data.msg);
              window.setTimeout(()=>{
                window.location.reload();
              },3000)
          }
      })
      .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
      })
    },


      changeMobileVerificationStatus() {
        this.isLoading = true;
        var userToken = window.localStorage.getItem('userToken')
        var myStr     = userToken.replace(/"/g, '');
        let reqpayload = {
          'userid' : this.mobileflaguserid,
          'ismobileverified': true,
          'lastmodifiedby':this.localusermailid
        }

        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'user/updateMobileVerificationStatus',
            'data': reqpayload,
            headers: {
                'Authorization': 'Bearer ' + myStr
            }
        })
        .then((response) => {
          this.isLoading = false;
            if (response.data.code == 200) {
              this.mobileverificationmodalShow = false;
             this.searchUserData();
                this.$alertify.success(response.data.msg);
            } else {
                this.$alertify.error(response.data.msg)
            }
        })
        .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
        })
      },
        getUserData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
                offset: this.pageno,
                limit: 10,
                firstname: this.username,
                email: this.email,
                MobileNumber: this.mobilenumber,
                utype: this.utype,
                status: this.userstatus,
                HubId: this.hubid.id,
                OldDeliveryUserOrUserId: this.olduserid,
                userid: this.newuserid,
                projectid: this.trackname,
                roleid : this.rolename,
                clientid:this.clientid.id
            })
            var pushArray = [];
            if(this.email || this.username || this.mobilenumber || this.utype || this.userstatus || this.hubid.id || this.newuserid || this.olduserid || this.clientid.id){
              pushArray.push({
                offset: this.pageno,
                limit: 10,
                firstname: this.username,
                OldDeliveryUserOrUserId: this.olduserid,
                userid: this.newuserid,
                email: this.email,
                MobileNumber: this.mobilenumber,
                utype: this.utype,
                status: this.userstatus,
                HubId: this.hubid.id,
                projectid: this.trackname,
                roleid : this.rolename,
                clientid : this.clientid.id
              })
            }
            if(pushArray.length > 0){
              var payloadObj = pushArray[0]
            }
            else {
              var payloadObj = this.input
            }
            window.localStorage.setItem('LSEmail',payloadObj.email);
            window.localStorage.setItem('LSUsername',payloadObj.firstname);
            window.localStorage.setItem('LSMobile',payloadObj.MobileNumber);
            window.localStorage.setItem('LSUtype',payloadObj.utype);
            window.localStorage.setItem('LSStatus',payloadObj.status);
            window.localStorage.setItem('LSHubId',payloadObj.HubId);
            window.localStorage.setItem('LSHub',this.hubid.label);
            window.localStorage.setItem('LSuserids',payloadObj.userid);
            window.localStorage.setItem('LSolduserid',payloadObj.OldDeliveryUserOrUserId);
            window.localStorage.setItem('LSClientId',payloadObj.clientid);
            window.localStorage.setItem('LSClient',this.clientid.label);
            var localinputHubid = window.localStorage.getItem('LSHubId')
            var localinputHub = window.localStorage.getItem('LSHub')

            this.isLoading = true;

            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'userMaster',
                    'data': payloadObj,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(result => {
                    this.usercount = result.data.count
                    this.listUserData = result.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count
                    this.resultCount = result.data.count
                    if (totalRows < 10) {
                        this.pagecount = 1
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10)
                    }
                }, error => {
                    console.error(error)
                })
        },
        getUserRowData(userid) {
            this.$router.push('/register/'+userid);
        },
        //to get pagination
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10
            this.getUserData()
        },
        //to get target id in active/inactive modal
        getStatusRowData(data) {
            this.modalShow = true

            this.userid = data.userid
            this.status = data.status
            if (data.status == true) {
                this.changestatus = 'De-Activate'
            } else {
                this.changestatus = 'Activate'
            }
        },
        //to get target id in forcedLogout modal
        getforcedLogoutRowData(userid,logOutDevice) {
            this.forcedLogoutmodalShow = true
            this.userid = userid
            this.logOutDevice  = logOutDevice
        },
        //display client data
        clientData(data) {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          this.input = {
            'userid': data.userid
          };
          axios({
            method: "POST",
            url: apiUrl.api_url + "getClientUserData",
            data: this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          }).then(
            result => {
              let status = "valid";
              this.clientUserData = result.data.result;
              let obj = result.data.result;
              if (obj.username && obj.manifestsecretkey) {
                if (obj.password || obj.clientpassword) {
                  status= "valid"
                }
                else {
                  status="Invalid"
                }
              }
              else {
                status="invalid"
              }
              if (status=="valid") {
                if (obj.clientpassword) {
                  let password_result =obj.clientpassword
                  this.clientUserData.clientpassword = CommonFunctions.prototype.decryptText(obj.clientpassword);
                  if(this.clientUserData.clientpassword=="" || this.clientUserData.clientpassword==false){
                    this.clientUserData.clientpassword = password_result
                  }
                  delete this.clientUserData.password
                }
                else if (obj.password && !obj.clientpassword) {
                  this.clientUserData.password = CommonFunctions.prototype.decryptText(obj.password);
                  delete this.clientUserData.clientpassword
                }
                this.modalclient = true
              }
              else {
                  this.$alertify.error("Please map client user details.");
              }
            },
            error => {
              console.error(error);
            }
          );
          //this.userid = userid
         // this.logOutDevice  = logOutDevice
      },

      closeclientDataModal() {
        this.modalclient = false
        this.isCopy =false
        this.successMsg = ''
    },
    closeSuccessMsg(){
      this.successMsg = false;
    },
    checkClientAuth(data){
      document.getElementById("checkBtn").disabled = true;
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.inputPayload ={
        username: data.username,
        password: data.password?data.password:data.clientpassword,
        secretkey: data.manifestsecretkey
      }
        axios({
          method: "POST",
          url: apiUrl.api_url + "checkClientAuth",
          data: this.inputPayload,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        }).then(
          result => {
            this.checklivestatus=result.data.checklivestatus
            if (result.data.code == 200) {
              document.getElementById("checkBtn").disabled = false;
              this.successMsg = 'Authentication Successful.';
              //this.$alertify.success("Authentication Successful.");
            }else if (result.data.code == 103) {
              document.getElementById("checkBtn").disabled = false;
              this.successMsg = 'Authentication Failed.';
              this.checklivestatus=result.data.checklivestatus
              //this.$alertify.success("Authentication Successful.");
            }
            else {
              document.getElementById("checkBtn").disabled = false;
              this.successMsg = 'Authentication Failed.';

              //this.$alertify.error("Authentication Failed.");
            }
          },
          error => {
            document.getElementById("checkBtn").disabled = false;
            this.successMsg = 'Authentication Failed.';
            //this.$alertify.error("Authentication Failed.");
          }
        );
    },
        //for active/inactive modal
        changeUserStatus() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            let reqpayload = {
                'userid': this.userid,
                'status': this.status,
                'createdby':this.localusermailid
            }

            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'updateUserStatus',
                    'data': {
                        'userid': this.userid,
                        'status': this.status,
                    },
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    if (response.data.errorCode == 0) {
                        this.$alertify.success(response.data.msg);
                        this.getUserData()
                    } else if (response.data.errorCode == -1) {
                        this.$alertify.error(response.data.msg)
                    }
                    iptrackerdetails.checkUserIP(this.iptrackData,'changeUserStatus',this.$route.path,reqpayload,response.data);

                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },
        //for Desktop user force loggout
        forcedLoggoutUser() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'forcedloggoutuser',
                    'data': {
                        'userid': this.userid,
                        'logoutdevice': this.logOutDevice,
                        'modifiedby': this.localusermailid
                    },
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    if (response.data.errorCode == 0) {
                        this.$alertify.success(response.data.msg);
                        this.forcedLogoutmodalShow = false;
                        this.getUserData()
                    } else if (response.data.errorCode == -1) {
                        this.$alertify.error(response.data.msg)
                    }
                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },

        resetForm() {
            this.username = '';
            this.newuserid = '';
            this.olduserid = '';
            this.trackname = '';
            this.showRoles = false;
            this.rolename = '';
            this.mobilenumber = '';
            this.email = '';
            this.utype = '';
            this.userstatus = '';
            this.hubid = '';
            this.clientid ='';
            this.pageno = 0;
            this.$refs.paginate.selected = 0;
            this.getUserData();
        },

        //to get User Type list
        getUserTypeData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getusertypelist',
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.listUserTypeData = result.data.data.rows;
            }, error => {
              console.error(error)
            })
        },

        //to get Hub Service Center list
        getHubServiceCenterData() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = {}
          axios({
              method: 'GET',
              url: apiUrl.api_url + 'external/gethubservicecenterlist',
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              var data = [];
              result.data.hubs.data.forEach(function (hubData) {
                data.push({
                  id:hubData.HubID,
                  label:hubData.HubName + "("+hubData.HubID+")"
                });
              });
              this.hubServiceCenterList = data;
            }, error => {
              console.error(error)
            })
        },
        showTripCloseModal(userid){
          this.tripuserid = userid
          this.tripclosemodal = true
        },
        closemodal(){
          this.triptrack = ''
          this.tripclosemodal = false
        },
        closeTrip(){
          this.$validator.validateAll().then((result) => {
            if (result) {
              var userToken = window.localStorage.getItem('userToken')
              var myStr = userToken.replace(/"/g, '');

              this.input = {
                userid : this.tripuserid,
                tripTrack : this.triptrack,
                lastmodifiedby : this.localusermailid
              }
              this.isLoading = true
              this.tripclosemodal = false
              axios({
                method : 'POST',
                url :  apiUrl.api_url + 'forceCloseSRTrip',
                data : this.input
              }).then(result => {
                (result.data.code == 200) ? this.$alertify.success(result.data.msg) : this.$alertify.alert(result.data.msg)
                this.triptrack = ''
                this.isLoading = false
              })
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        },

        getRolesByTrack(){
          this.showRoles = true
          this.getProjectRoles_list(this.trackname)
        },
        getTrackNames() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');
          this.istrackloader = true
          this.input = ({
            offset: this.pageno,
            limit: 10,
            projectname: this.searchprojectname
          })
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getprojectlist',
              'data': this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              let data = []
              result.data.data.rows.forEach(function (trackData) {
                data.push({
                  label:trackData.projectname,
                  id:trackData.projectid
                });
              });
              this.listTrackData = data;
              this.istrackloader = false
            }, error => {
              console.error(error)
            })
          },
          getProjectRoles_list(project_id) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            let projectid;
            if(project_id == null){
              projectid = this.projectid;
            }else{
              projectid = project_id;
            }
            if(projectid==null){
              return false;
            }
            this.input = {
              projectid: project_id
            };
            if(this.hubid){
              let hubarr = []
              hubarr.push(this.hubid.id)
              this.input.hubid = hubarr
            }
            this.isRoleloader = true
            axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getTrackwiseRolesByHub',
                data: this.input,
                headers: {
                  'Authorization': 'Bearer ' + myStr
                }
              })
              .then(result => {
                this.isRoleloader = false
                this.listRolesData = result.data;
              }, error => {
                console.error(error)
              })
          },
          resetTrackRole(){
            this.trackname = '';
            this.rolename = ''
          },
          UpdateUserHubs(userid) {
              this.$router.push('/maphubsusers/'+userid);
          },
          UpdateUserSubdepartment(userid) {
            this.$router.push('/accesssubdepartment/'+userid);
        },
          selectUserType(){
            if (this.utype!=1) {
                this.clientid ='';
              }
            }
         }

}



// WEBPACK FOOTER //
// ./src/views/components/user/user.component.js